module.exports = __webpack_public_path__ + "static/img/freeze.555d322.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/freeze.png
// module id = wEpc
// module chunks = 37